import { render } from "./StatisticData.vue?vue&type=template&id=be5257ca"
import script from "./StatisticData.vue?vue&type=script&lang=js"
export * from "./StatisticData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__